import { useMutation, useQueryClient } from '@tanstack/react-query';
import { routeQueryKeys, Routes } from '#api';
import { makeRouteQueryOptions } from '#api/routes.queries.ts';

export function useDeleteRoute() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (routeId: `route-${string}`) => Routes.deleteRoute(routeId),
    onSuccess(data, routeId) {
      void queryClient.invalidateQueries({ queryKey: routeQueryKeys.lists() });
      queryClient.removeQueries({ ...makeRouteQueryOptions(routeId), exact: true });
    },
  });
}
